// Country dataset for the school management platform.
// Each entry: { code (ISO 3166-1 alpha-2), name_es, name_en, dial }
// The two pinned countries (US, CA) come first; the rest is alphabetical (Spanish).
//
// Flag emojis are derived from the ISO code at render time via `flagEmoji(code)`
// so we don't have to hardcode 200+ flag characters.

const RAW = [
  { code: "US", name_es: "Estados Unidos", name_en: "United States", dial: "+1" },
  { code: "CA", name_es: "Canadá", name_en: "Canada", dial: "+1" },
  { code: "CR", name_es: "Costa Rica", name_en: "Costa Rica", dial: "+506" },
  // --- rest, alphabetical (Spanish) ---
  { code: "AF", name_es: "Afganistán", name_en: "Afghanistan", dial: "+93" },
  { code: "AL", name_es: "Albania", name_en: "Albania", dial: "+355" },
  { code: "DE", name_es: "Alemania", name_en: "Germany", dial: "+49" },
  { code: "AD", name_es: "Andorra", name_en: "Andorra", dial: "+376" },
  { code: "AO", name_es: "Angola", name_en: "Angola", dial: "+244" },
  { code: "AG", name_es: "Antigua y Barbuda", name_en: "Antigua and Barbuda", dial: "+1268" },
  { code: "SA", name_es: "Arabia Saudita", name_en: "Saudi Arabia", dial: "+966" },
  { code: "DZ", name_es: "Argelia", name_en: "Algeria", dial: "+213" },
  { code: "AR", name_es: "Argentina", name_en: "Argentina", dial: "+54" },
  { code: "AM", name_es: "Armenia", name_en: "Armenia", dial: "+374" },
  { code: "AU", name_es: "Australia", name_en: "Australia", dial: "+61" },
  { code: "AT", name_es: "Austria", name_en: "Austria", dial: "+43" },
  { code: "AZ", name_es: "Azerbaiyán", name_en: "Azerbaijan", dial: "+994" },
  { code: "BS", name_es: "Bahamas", name_en: "Bahamas", dial: "+1242" },
  { code: "BD", name_es: "Bangladés", name_en: "Bangladesh", dial: "+880" },
  { code: "BB", name_es: "Barbados", name_en: "Barbados", dial: "+1246" },
  { code: "BH", name_es: "Baréin", name_en: "Bahrain", dial: "+973" },
  { code: "BE", name_es: "Bélgica", name_en: "Belgium", dial: "+32" },
  { code: "BZ", name_es: "Belice", name_en: "Belize", dial: "+501" },
  { code: "BJ", name_es: "Benín", name_en: "Benin", dial: "+229" },
  { code: "BY", name_es: "Bielorrusia", name_en: "Belarus", dial: "+375" },
  { code: "BO", name_es: "Bolivia", name_en: "Bolivia", dial: "+591" },
  { code: "BA", name_es: "Bosnia y Herzegovina", name_en: "Bosnia and Herzegovina", dial: "+387" },
  { code: "BW", name_es: "Botsuana", name_en: "Botswana", dial: "+267" },
  { code: "BR", name_es: "Brasil", name_en: "Brazil", dial: "+55" },
  { code: "BN", name_es: "Brunéi", name_en: "Brunei", dial: "+673" },
  { code: "BG", name_es: "Bulgaria", name_en: "Bulgaria", dial: "+359" },
  { code: "BF", name_es: "Burkina Faso", name_en: "Burkina Faso", dial: "+226" },
  { code: "BI", name_es: "Burundi", name_en: "Burundi", dial: "+257" },
  { code: "BT", name_es: "Bután", name_en: "Bhutan", dial: "+975" },
  { code: "CV", name_es: "Cabo Verde", name_en: "Cape Verde", dial: "+238" },
  { code: "KH", name_es: "Camboya", name_en: "Cambodia", dial: "+855" },
  { code: "CM", name_es: "Camerún", name_en: "Cameroon", dial: "+237" },
  { code: "QA", name_es: "Catar", name_en: "Qatar", dial: "+974" },
  { code: "TD", name_es: "Chad", name_en: "Chad", dial: "+235" },
  { code: "CL", name_es: "Chile", name_en: "Chile", dial: "+56" },
  { code: "CN", name_es: "China", name_en: "China", dial: "+86" },
  { code: "CY", name_es: "Chipre", name_en: "Cyprus", dial: "+357" },
  { code: "VA", name_es: "Ciudad del Vaticano", name_en: "Vatican City", dial: "+379" },
  { code: "CO", name_es: "Colombia", name_en: "Colombia", dial: "+57" },
  { code: "KM", name_es: "Comoras", name_en: "Comoros", dial: "+269" },
  { code: "KP", name_es: "Corea del Norte", name_en: "North Korea", dial: "+850" },
  { code: "KR", name_es: "Corea del Sur", name_en: "South Korea", dial: "+82" },
  { code: "CI", name_es: "Costa de Marfil", name_en: "Ivory Coast", dial: "+225" },
  { code: "HR", name_es: "Croacia", name_en: "Croatia", dial: "+385" },
  { code: "CU", name_es: "Cuba", name_en: "Cuba", dial: "+53" },
  { code: "DK", name_es: "Dinamarca", name_en: "Denmark", dial: "+45" },
  { code: "DM", name_es: "Dominica", name_en: "Dominica", dial: "+1767" },
  { code: "EC", name_es: "Ecuador", name_en: "Ecuador", dial: "+593" },
  { code: "EG", name_es: "Egipto", name_en: "Egypt", dial: "+20" },
  { code: "SV", name_es: "El Salvador", name_en: "El Salvador", dial: "+503" },
  { code: "AE", name_es: "Emiratos Árabes Unidos", name_en: "United Arab Emirates", dial: "+971" },
  { code: "ER", name_es: "Eritrea", name_en: "Eritrea", dial: "+291" },
  { code: "SK", name_es: "Eslovaquia", name_en: "Slovakia", dial: "+421" },
  { code: "SI", name_es: "Eslovenia", name_en: "Slovenia", dial: "+386" },
  { code: "ES", name_es: "España", name_en: "Spain", dial: "+34" },
  { code: "EE", name_es: "Estonia", name_en: "Estonia", dial: "+372" },
  { code: "ET", name_es: "Etiopía", name_en: "Ethiopia", dial: "+251" },
  { code: "PH", name_es: "Filipinas", name_en: "Philippines", dial: "+63" },
  { code: "FI", name_es: "Finlandia", name_en: "Finland", dial: "+358" },
  { code: "FJ", name_es: "Fiyi", name_en: "Fiji", dial: "+679" },
  { code: "FR", name_es: "Francia", name_en: "France", dial: "+33" },
  { code: "GA", name_es: "Gabón", name_en: "Gabon", dial: "+241" },
  { code: "GM", name_es: "Gambia", name_en: "Gambia", dial: "+220" },
  { code: "GE", name_es: "Georgia", name_en: "Georgia", dial: "+995" },
  { code: "GH", name_es: "Ghana", name_en: "Ghana", dial: "+233" },
  { code: "GD", name_es: "Granada", name_en: "Grenada", dial: "+1473" },
  { code: "GR", name_es: "Grecia", name_en: "Greece", dial: "+30" },
  { code: "GT", name_es: "Guatemala", name_en: "Guatemala", dial: "+502" },
  { code: "GY", name_es: "Guyana", name_en: "Guyana", dial: "+592" },
  { code: "GN", name_es: "Guinea", name_en: "Guinea", dial: "+224" },
  { code: "GW", name_es: "Guinea-Bisáu", name_en: "Guinea-Bissau", dial: "+245" },
  { code: "GQ", name_es: "Guinea Ecuatorial", name_en: "Equatorial Guinea", dial: "+240" },
  { code: "HT", name_es: "Haití", name_en: "Haiti", dial: "+509" },
  { code: "HN", name_es: "Honduras", name_en: "Honduras", dial: "+504" },
  { code: "HU", name_es: "Hungría", name_en: "Hungary", dial: "+36" },
  { code: "IN", name_es: "India", name_en: "India", dial: "+91" },
  { code: "ID", name_es: "Indonesia", name_en: "Indonesia", dial: "+62" },
  { code: "IQ", name_es: "Irak", name_en: "Iraq", dial: "+964" },
  { code: "IR", name_es: "Irán", name_en: "Iran", dial: "+98" },
  { code: "IE", name_es: "Irlanda", name_en: "Ireland", dial: "+353" },
  { code: "IS", name_es: "Islandia", name_en: "Iceland", dial: "+354" },
  { code: "IL", name_es: "Israel", name_en: "Israel", dial: "+972" },
  { code: "IT", name_es: "Italia", name_en: "Italy", dial: "+39" },
  { code: "JM", name_es: "Jamaica", name_en: "Jamaica", dial: "+1876" },
  { code: "JP", name_es: "Japón", name_en: "Japan", dial: "+81" },
  { code: "JO", name_es: "Jordania", name_en: "Jordan", dial: "+962" },
  { code: "KZ", name_es: "Kazajistán", name_en: "Kazakhstan", dial: "+7" },
  { code: "KE", name_es: "Kenia", name_en: "Kenya", dial: "+254" },
  { code: "KG", name_es: "Kirguistán", name_en: "Kyrgyzstan", dial: "+996" },
  { code: "KI", name_es: "Kiribati", name_en: "Kiribati", dial: "+686" },
  { code: "KW", name_es: "Kuwait", name_en: "Kuwait", dial: "+965" },
  { code: "LA", name_es: "Laos", name_en: "Laos", dial: "+856" },
  { code: "LS", name_es: "Lesoto", name_en: "Lesotho", dial: "+266" },
  { code: "LV", name_es: "Letonia", name_en: "Latvia", dial: "+371" },
  { code: "LB", name_es: "Líbano", name_en: "Lebanon", dial: "+961" },
  { code: "LR", name_es: "Liberia", name_en: "Liberia", dial: "+231" },
  { code: "LY", name_es: "Libia", name_en: "Libya", dial: "+218" },
  { code: "LI", name_es: "Liechtenstein", name_en: "Liechtenstein", dial: "+423" },
  { code: "LT", name_es: "Lituania", name_en: "Lithuania", dial: "+370" },
  { code: "LU", name_es: "Luxemburgo", name_en: "Luxembourg", dial: "+352" },
  { code: "MK", name_es: "Macedonia del Norte", name_en: "North Macedonia", dial: "+389" },
  { code: "MG", name_es: "Madagascar", name_en: "Madagascar", dial: "+261" },
  { code: "MY", name_es: "Malasia", name_en: "Malaysia", dial: "+60" },
  { code: "MW", name_es: "Malaui", name_en: "Malawi", dial: "+265" },
  { code: "MV", name_es: "Maldivas", name_en: "Maldives", dial: "+960" },
  { code: "ML", name_es: "Malí", name_en: "Mali", dial: "+223" },
  { code: "MT", name_es: "Malta", name_en: "Malta", dial: "+356" },
  { code: "MA", name_es: "Marruecos", name_en: "Morocco", dial: "+212" },
  { code: "MU", name_es: "Mauricio", name_en: "Mauritius", dial: "+230" },
  { code: "MR", name_es: "Mauritania", name_en: "Mauritania", dial: "+222" },
  { code: "MX", name_es: "México", name_en: "Mexico", dial: "+52" },
  { code: "FM", name_es: "Micronesia", name_en: "Micronesia", dial: "+691" },
  { code: "MD", name_es: "Moldavia", name_en: "Moldova", dial: "+373" },
  { code: "MC", name_es: "Mónaco", name_en: "Monaco", dial: "+377" },
  { code: "MN", name_es: "Mongolia", name_en: "Mongolia", dial: "+976" },
  { code: "ME", name_es: "Montenegro", name_en: "Montenegro", dial: "+382" },
  { code: "MZ", name_es: "Mozambique", name_en: "Mozambique", dial: "+258" },
  { code: "MM", name_es: "Myanmar", name_en: "Myanmar", dial: "+95" },
  { code: "NA", name_es: "Namibia", name_en: "Namibia", dial: "+264" },
  { code: "NR", name_es: "Nauru", name_en: "Nauru", dial: "+674" },
  { code: "NP", name_es: "Nepal", name_en: "Nepal", dial: "+977" },
  { code: "NI", name_es: "Nicaragua", name_en: "Nicaragua", dial: "+505" },
  { code: "NE", name_es: "Níger", name_en: "Niger", dial: "+227" },
  { code: "NG", name_es: "Nigeria", name_en: "Nigeria", dial: "+234" },
  { code: "NO", name_es: "Noruega", name_en: "Norway", dial: "+47" },
  { code: "NZ", name_es: "Nueva Zelanda", name_en: "New Zealand", dial: "+64" },
  { code: "OM", name_es: "Omán", name_en: "Oman", dial: "+968" },
  { code: "NL", name_es: "Países Bajos", name_en: "Netherlands", dial: "+31" },
  { code: "PK", name_es: "Pakistán", name_en: "Pakistan", dial: "+92" },
  { code: "PW", name_es: "Palaos", name_en: "Palau", dial: "+680" },
  { code: "PA", name_es: "Panamá", name_en: "Panama", dial: "+507" },
  { code: "PG", name_es: "Papúa Nueva Guinea", name_en: "Papua New Guinea", dial: "+675" },
  { code: "PY", name_es: "Paraguay", name_en: "Paraguay", dial: "+595" },
  { code: "PE", name_es: "Perú", name_en: "Peru", dial: "+51" },
  { code: "PL", name_es: "Polonia", name_en: "Poland", dial: "+48" },
  { code: "PT", name_es: "Portugal", name_en: "Portugal", dial: "+351" },
  { code: "PR", name_es: "Puerto Rico", name_en: "Puerto Rico", dial: "+1787" },
  { code: "GB", name_es: "Reino Unido", name_en: "United Kingdom", dial: "+44" },
  { code: "CF", name_es: "República Centroafricana", name_en: "Central African Republic", dial: "+236" },
  { code: "CZ", name_es: "República Checa", name_en: "Czech Republic", dial: "+420" },
  { code: "CG", name_es: "República del Congo", name_en: "Republic of the Congo", dial: "+242" },
  { code: "CD", name_es: "República Democrática del Congo", name_en: "DR Congo", dial: "+243" },
  { code: "DO", name_es: "República Dominicana", name_en: "Dominican Republic", dial: "+1809" },
  { code: "RW", name_es: "Ruanda", name_en: "Rwanda", dial: "+250" },
  { code: "RO", name_es: "Rumanía", name_en: "Romania", dial: "+40" },
  { code: "RU", name_es: "Rusia", name_en: "Russia", dial: "+7" },
  { code: "WS", name_es: "Samoa", name_en: "Samoa", dial: "+685" },
  { code: "KN", name_es: "San Cristóbal y Nieves", name_en: "Saint Kitts and Nevis", dial: "+1869" },
  { code: "SM", name_es: "San Marino", name_en: "San Marino", dial: "+378" },
  { code: "VC", name_es: "San Vicente y las Granadinas", name_en: "Saint Vincent and the Grenadines", dial: "+1784" },
  { code: "LC", name_es: "Santa Lucía", name_en: "Saint Lucia", dial: "+1758" },
  { code: "ST", name_es: "Santo Tomé y Príncipe", name_en: "Sao Tome and Principe", dial: "+239" },
  { code: "SN", name_es: "Senegal", name_en: "Senegal", dial: "+221" },
  { code: "RS", name_es: "Serbia", name_en: "Serbia", dial: "+381" },
  { code: "SC", name_es: "Seychelles", name_en: "Seychelles", dial: "+248" },
  { code: "SL", name_es: "Sierra Leona", name_en: "Sierra Leone", dial: "+232" },
  { code: "SG", name_es: "Singapur", name_en: "Singapore", dial: "+65" },
  { code: "SY", name_es: "Siria", name_en: "Syria", dial: "+963" },
  { code: "SO", name_es: "Somalia", name_en: "Somalia", dial: "+252" },
  { code: "LK", name_es: "Sri Lanka", name_en: "Sri Lanka", dial: "+94" },
  { code: "ZA", name_es: "Sudáfrica", name_en: "South Africa", dial: "+27" },
  { code: "SD", name_es: "Sudán", name_en: "Sudan", dial: "+249" },
  { code: "SS", name_es: "Sudán del Sur", name_en: "South Sudan", dial: "+211" },
  { code: "SE", name_es: "Suecia", name_en: "Sweden", dial: "+46" },
  { code: "CH", name_es: "Suiza", name_en: "Switzerland", dial: "+41" },
  { code: "SR", name_es: "Surinam", name_en: "Suriname", dial: "+597" },
  { code: "TH", name_es: "Tailandia", name_en: "Thailand", dial: "+66" },
  { code: "TW", name_es: "Taiwán", name_en: "Taiwan", dial: "+886" },
  { code: "TZ", name_es: "Tanzania", name_en: "Tanzania", dial: "+255" },
  { code: "TJ", name_es: "Tayikistán", name_en: "Tajikistan", dial: "+992" },
  { code: "TL", name_es: "Timor Oriental", name_en: "East Timor", dial: "+670" },
  { code: "TG", name_es: "Togo", name_en: "Togo", dial: "+228" },
  { code: "TO", name_es: "Tonga", name_en: "Tonga", dial: "+676" },
  { code: "TT", name_es: "Trinidad y Tobago", name_en: "Trinidad and Tobago", dial: "+1868" },
  { code: "TN", name_es: "Túnez", name_en: "Tunisia", dial: "+216" },
  { code: "TM", name_es: "Turkmenistán", name_en: "Turkmenistan", dial: "+993" },
  { code: "TR", name_es: "Turquía", name_en: "Turkey", dial: "+90" },
  { code: "TV", name_es: "Tuvalu", name_en: "Tuvalu", dial: "+688" },
  { code: "UA", name_es: "Ucrania", name_en: "Ukraine", dial: "+380" },
  { code: "UG", name_es: "Uganda", name_en: "Uganda", dial: "+256" },
  { code: "UY", name_es: "Uruguay", name_en: "Uruguay", dial: "+598" },
  { code: "UZ", name_es: "Uzbekistán", name_en: "Uzbekistan", dial: "+998" },
  { code: "VU", name_es: "Vanuatu", name_en: "Vanuatu", dial: "+678" },
  { code: "VE", name_es: "Venezuela", name_en: "Venezuela", dial: "+58" },
  { code: "VN", name_es: "Vietnam", name_en: "Vietnam", dial: "+84" },
  { code: "YE", name_es: "Yemen", name_en: "Yemen", dial: "+967" },
  { code: "DJ", name_es: "Yibuti", name_en: "Djibouti", dial: "+253" },
  { code: "ZM", name_es: "Zambia", name_en: "Zambia", dial: "+260" },
  { code: "ZW", name_es: "Zimbabue", name_en: "Zimbabwe", dial: "+263" },
];

export const COUNTRIES = RAW;
export const COUNTRIES_MAP = Object.fromEntries(RAW.map((c) => [c.code, c]));

// Convert an ISO 3166-1 alpha-2 code into a flag emoji using Unicode regional
// indicator symbols. e.g. "US" → 🇺🇸. Browsers without flag glyph support
// (some Windows builds) will show the letters instead — acceptable fallback.
export function flagEmoji(code) {
  if (!code || code.length !== 2) return "🏳️";
  const base = 0x1f1e6;
  const cp = (ch) => base + (ch.toUpperCase().charCodeAt(0) - 65);
  return String.fromCodePoint(cp(code[0]), cp(code[1]));
}

export function countryName(code, lang = "es") {
  const c = COUNTRIES_MAP[code];
  if (!c) return code || "";
  return lang === "en" ? c.name_en : c.name_es;
}

export function countryLabel(code, lang = "es") {
  if (!code) return "";
  return `${flagEmoji(code)} ${countryName(code, lang)}`;
}
